import React from 'react';
import PropTypes from 'prop-types';
import { NavigationBar } from './NavigationBar';
import { Header } from './styles';

export const BaseHeader = ({
  topSegment,
  leftSegment,
  centerSegment,
  rightSegment,
  bottomSegment,
  logoUrl,
  logoSrText,
  sticky = false,
  stickyBanner = false,
  variant,
  cro,
  showLogo = true,
  withDropShadow = false,
  centerLogo,
}) => {
  return (
    <Header
      role="banner"
      $cro={cro}
      $centerLogo={centerLogo}
      $hasBanner={!!topSegment}
      $sticky={sticky}
      $stickyBanner={stickyBanner}
      $dropshadow={withDropShadow}
    >
      {topSegment}
      <div>
        <NavigationBar
          showLogo={showLogo}
          logoUrl={logoUrl}
          logoSrText={logoSrText}
          leftSegment={leftSegment}
          centerSegment={centerSegment}
          rightSegment={rightSegment}
          variant={variant}
        />
      </div>
      {bottomSegment}
    </Header>
  );
};

BaseHeader.displayName = 'BaseHeader';

BaseHeader.propTypes = {
  variant: PropTypes.string,
  logoUrl: PropTypes.string,
  logoSrText: PropTypes.string,
  topSegment: PropTypes.node,
  leftSegment: PropTypes.node,
  centerSegment: PropTypes.node,
  rightSegment: PropTypes.node,
  bottomSegment: PropTypes.node,
  sticky: PropTypes.bool,
  stickyBanner: PropTypes.bool,
  showLogo: PropTypes.bool,
  cro: PropTypes.bool,
  centerLogo: PropTypes.bool,
};
